import { createStorage } from '@matix/utils';

/**
 * The cashier's current UI language, readable OUTSIDE React.
 *
 * `useLang` is a context and the print paths are not components — the receipt
 * store is zustand, and `printAfterCharge` runs from a mutation callback. Both
 * need the language at the moment of printing, so they read the same persisted
 * value the provider writes (`pos:cashier` → `login_lang`), which is also the
 * login screen's choice.
 *
 * The whole receipt prints in this language (see `ReceiptData.language`) — the
 * 72 mm thermal ticket as well as the A4 invoice. A tenant that never sends one
 * (the server-side print paths) still falls back to ArabiReset.
 */
const STORE = createStorage('pos:cashier');
const LANG_KEY = 'login_lang';

export function currentPrintLanguage(): 'ar' | 'en' {
  try {
    return STORE.get<string>(LANG_KEY) === 'ar' ? 'ar' : 'en';
  } catch {
    // Storage can throw in private-mode browsers; English is the app default.
    return 'en';
  }
}
